import {cpfCnpj, cents} from '../../../../../filters/string'
import Tolls from '../../../../../services/toll';

export default {
  props: ['routeSelected', 'aggregate'],
  data() {
    return {
      loading: undefined,
      priceTolls: {},
      open: true,
      origin: {},
      destination: {},
      showDetails: false
    }
  },
  mounted() {
    let vm = this;
    let tolls = [];

    if (this.routeSelected) {
      this.routeSelected.points.find(function(o){
        if (o.type == 'origin') {
          vm.origin = {'city': o.city, 'state': o.state};
        } else if (o.type == 'destination') {
          vm.destination = {'city': o.city, 'state': o.state};
        }
      });
    }

    this.routeSelected.tollFees.forEach(element => {
      element.radius = element.radius == "" ? 0 : element.radius;
      tolls.push(element);
    });

    this.loading = Tolls.getPriceTolls({tolls , axes: this.aggregate.categoryAxesId}).then(r => {
      this.priceTolls = r;
    }).catch(err => {
      
    });

    this.showDetails = true
  },

}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/toll-ticket/summary.js